<!-- src/components/SimpleAuditSelect.vue -->
<template>
  <el-dialog
      title="手动设置投递结果"
      :visible.sync="visible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleClose">

    <el-form label-width="100px">
      <el-form-item label="投递结果:">
        <el-radio-group v-model="selected">
          <el-radio label="pass">通过</el-radio>
          <el-radio label="noPass">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'setResultDialog',

  data() {
    return {
      visible: false,
      selected: ''
    };
  },

  methods: {
    // 打开对话框
    open() {
      this.visible = true;
    },

    // 关闭
    handleClose() {
      this.selected = '';
    },

    // 取消
    handleCancel() {
      this.visible = false;
      this.selected = '';
    },

    // 确认
    handleConfirm() {
      if (!this.selected) {
        this.$message.warning('请选择一个操作');
        return;
      }

      // 传回结果给父组件
      this.$emit('confirm', this.selected);

      // 关闭
      this.visible = false;
      this.selected = '';
    }
  }
};
</script>
